// extracted by mini-css-extract-plugin
export default {"cardRow":"ConsumerDetails_cardRow__zWVsC","card":"ConsumerDetails_card__bmhfQ"};